import React, { useContext } from "react";
import GlobalContext from "../../../isp._comun/iu/contexto/GlobalContext";

// import { Menubar } from "primereact/menubar";
// import { Image } from "primereact/image";
// import { Menu } from "primereact/menu";

import BotonMenu from "./BotonMenu";
import MenuItemsOrdenes from "./MenuItemsOrdenes";
import MenuItemsContratos from "./MenuItemsContratos";
import MenuItemsClientes from "./MenuItemsClientes";
import MenuItemsCatalogo from "./MenuItemsCatalogo";
import MenuItemsServicios from "./MenuItemsServicios";
import MenuItemsRRHH from "./MenuItemsRRHH";
import MenuItemsSeguridad from "./MenuItemsSeguridad";
import MenuConfiguracion from "./MenuItemsAdministracion";

// import * as Evento from "../../../_comun/Eventos";
import PanelCerrarSesion from "../../../isp.iu.idyacceso/componentes/PanelCerrarSesion";

const BarraMenu = () => {
    /* const {
        dispatchPrincipal,
    } = useContext(GlobalContext); */

    return (
        <div className="flex p-menubar mt-4 mx-4 px-0 py-0.5 justify-between">
            <div className="flex">
                <BotonMenu
                    label="Ordenes"
                    icono="pi pi-copy"
                    items={MenuItemsOrdenes()}
                ></BotonMenu>
                <BotonMenu
                    label="Clientes"
                    icono="pi pi-users"
                    items={MenuItemsClientes()}
                ></BotonMenu>
                <BotonMenu
                    label="Catalogo"
                    icono="pi pi-book"
                    items={MenuItemsCatalogo()}
                ></BotonMenu>
                <BotonMenu
                    label="Contratos"
                    icono="pi pi-copy"
                    items={MenuItemsContratos()}
                ></BotonMenu>
                <BotonMenu
                    label="Servicios"
                    icono="pi pi-server"
                    items={MenuItemsServicios()}
                ></BotonMenu>
                <BotonMenu
                    label="Recursos Humanos"
                    icono="pi pi-users"
                    items={MenuItemsRRHH()}
                ></BotonMenu>
                <BotonMenu
                    label="Seguridad"
                    icono="pi pi-lock"
                    items={MenuItemsSeguridad()}
                ></BotonMenu>
                <BotonMenu
                    label="Configuracion"
                    icono="pi pi-cog"
                    items={MenuConfiguracion()}
                ></BotonMenu>
                {/* <BotonMenu
                    label="Configuracion"
                    icono="pi pi-chart-line"
                    items={MenuConfiguracion()}
                ></BotonMenu> */}
            </div>

            <div id="usuarioLogueado" className="flex items-center rounded ml-1 mr-3">
                <i className="pi pi-fw pi-user mr-2" style={{ fontSize: "3em" }}></i>
                <div className="flex flex-col items-center">
                    <PanelCerrarSesion />
                </div>
            </div>
        </div>
    );
};
export default BarraMenu;
